// components/TrustBadges/badgesPart1.tsx — first 4 badge definitions
import type { BadgeItem, TrustBadgesProps } from './types';

export const buildBadgesPart1 = (badges: TrustBadgesProps['settings']['badges']): BadgeItem[] => [
    {
        key: 'securePayment',
        enabled: badges.securePayment,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
        ),
        text: 'Pembayaran Aman',
        color: 'text-emerald-600 dark:text-emerald-400'
    },
    {
        key: 'moneyBackGuarantee',
        enabled: badges.moneyBackGuarantee,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
        ),
        text: 'Garansi Uang Kembali',
        color: 'text-blue-600 dark:text-blue-400'
    },
    {
        key: 'codAvailable',
        enabled: badges.codAvailable,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
        ),
        text: 'COD Tersedia',
        color: 'text-amber-600 dark:text-amber-400'
    },
    {
        key: 'freeReturn',
        enabled: badges.freeReturn,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
            </svg>
        ),
        text: 'Gratis Retur 7 Hari',
        color: 'text-indigo-600 dark:text-indigo-400'
    },
];
